// removed by extract-text-webpack-plugin
module.exports = {"Base":"NotFound__Base-1xMJe","Content":"NotFound__Content-2MMod","Title":"NotFound__Title-3Vs9B","P":"NotFound__P-5sWlV","Search":"NotFound__Search-DboIp NotFound__P-5sWlV"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NotFound/NotFound.css
 ** module id = 655
 ** module chunks = 0
 **/